<template>
  <div class="c-card-wrapper">
    <v-card elevation="2" class="l-card" :loading="loading">
      <div class="header-card-wrapper card-wrapper--sensor">
        <v-card-title tag="p" class="crd-title">Device</v-card-title>
        <v-card-title tag="p" class="detail">{{deviceId}}</v-card-title>
        <ul class="tab">
            <li class="tab-item" :class="{'tab--active': actionActive == 'sensor'}" @click="tabCallback('sensor')">Sensors</li>
            <li class="tab-item" :class="{'tab--active': actionActive == 'record'}" @click="tabCallback('record')">Records</li>
        </ul>
      </div>
      <div class="action-top--sensor">
        <slot name="action-slot"></slot>
      </div>
      <div class="body-card-wrapper">
        <slot name="body-slot"></slot>
      </div>
      <div class="footer-card-wrapper">
        <slot name="footer-slot"></slot>
      </div>
    </v-card>
  </div>
</template>
<script>
import EventBus from '@/plugins/EventBus';
export default {
  props:{
    deviceId: {}
  },
  methods:{
    tabCallback(action){
      this.actionActive = action;
      this.$emit('tabCb', action);
    },
    setLoading(data){
      this.loading = data;
    }
  },
  data(){
    return {
      actionActive: 'sensor',
      loading: false
    }
  },
  created(){
    EventBus.$on("detailDeviceLoading", this.setLoading)
  },
  destroyed(){
    EventBus.$off("detailDeviceLoading", this.setLoading)
  }
}
</script>

<style lang="scss" scoped>
@import '@/components/styles/variable';
.card-wrapper--sensor{
    display: block !important;
    p{
        display: block;
        margin: 0;
        line-height: 1.3;
        padding-bottom: 0;
    }
    .detail{
      padding-top: 5px;
      padding-bottom: 10px;
      font-size: .89rem;
      color: rgba(#000, .4);
      font-weight: 400;
    }
}
.body-card-wrapper{
    margin-top: 10px;
}
.tab{
    list-style: none;
    margin-top: 10px;   
    padding-left: 16px;
    li{
        display: inline-block;
        font-size: 0.9rem;
        cursor: pointer;
        color: rgba(#000, 0.4);
        padding: 0 8px;
        border-bottom: 3px solid transparent;
        padding-bottom: 3px;
        & + li{
            margin-left: 1rem;
        }
        &.tab--active{
            color: rgba(#000, .7);
            font-weight: 500;
            border-bottom: 3px solid $color-primary;
        }
    }
}
.action-top--sensor{
    margin-top: 10px;
}
</style>